export default "__VITE_ASSET__36864cc2__"